import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageHeader from '../../common/pageHeader';
import ForgottenPassword from '../../common/forgottenPassword';
import ColorSkinWrapper from '../../common/colorSkinWrapper';
import { selectors as transitionRouterSelectors } from '../../common/transitionRouter';
import { selectors as bookmakersListSelectors } from '../../common/bookmakersList';

export const ForgottenPasswordPage = ({ match, name }) => (
    <ColorSkinWrapper
        bookmakerName={name}
        className={`bs-popover__content
                    bs-switchBookmakers__content
                    bs-horizontalSlider__element`}
    >
        <PageHeader
            backLinkUrl={`/${match.params.feed}/login`}
        />
        <ForgottenPassword match={match} />
    </ColorSkinWrapper>
);

ForgottenPasswordPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            feed: PropTypes.string,
        }),
    }).isRequired,
    name: PropTypes.string.isRequired,
};

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        transitionRouterSelectors.feedSelector,
    );

const mapStateToProps = (state, props) => (
    { ...bookmakerInfoSelector(state, props) }
);

export default connect(
    mapStateToProps,
    null,
)(ForgottenPasswordPage);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/forgottenPasswordPage/ForgottenPasswordPage.jsx